module.exports = __webpack_public_path__ + "static/img/0546_6.4344d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_6.jpg
// module id = DzEL
// module chunks = 1